module.exports = __webpack_public_path__ + "img/IC_Close_red.fa62ab38.svg";